<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <b-card :header="headerTitle" header-tag="h3" class="bg-default-card">
                    <data-table
                        v-if="tableLoaded"
                        :search="search"
                        :exportable="false"
                        :rows="rowData"
                        :columns="columnData"
                        :paginate="false"
                    >
                    </data-table>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import http from '@/libs/http';
import miniToastr from 'mini-toastr';

export default {
    name: 'progress_from',
    components: {
        DataTable,
        miniToastr,
    },
    props: {
        tableName: {
            type: String,
            required: true
        },
        search: {
            type: Boolean,
            default: false,
        },
        columnData: {
            type: Array,
            required: true
        },
        headerTitle: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            tableLoaded: false,
            rowData: [],
        }
    },
    mounted() {
        this.onLoadTable();
    },
    methods: {
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        onLoadTable () {
            let data = http.route(this.tableName + '?project_id=' + this.$route.params.id).get();
            data.then(response => {
                if (!response.isError) {
                    this.rowData     = response.data;
                    this.tableLoaded = true;
                    this.$emit('onLoadTable', response);
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/percent_progress/common/tables/progress_from.vue